// @ts-nocheck
import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip } from 'chart.js';
import { sx } from '../sx';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip);

const BLUE = '#0052CD';
const FORECASTS = ['#F5A623', '#8B5CF6', '#12A594'];
const GREYS = ['#A9B4C8', '#C4CCDA', '#D8DEE9'];

function styleOf(s, idx) {
  if (s.kind === 'actual') return { color: BLUE, width: 2, point: 2 };
  if (s.kind === 'forecast') return { color: FORECASTS[Math.min(idx, FORECASTS.length - 1)], width: 2, point: 2 };
  return { color: GREYS[Math.min(idx, GREYS.length - 1)], width: 1.5, point: 2 };
}

export default function RowTrendCard({ vm }: { vm: any }) {
  const trend = vm.chartOpen ? vm.chartTrend : null;
  const { data, options, legend } = useMemo(() => {
    if (!trend) return { data: null, options: null, legend: [] };
    // newest past year gets the darkest grey
    const pastTotal = trend.series.filter(s => s.kind === 'past').length;
    let seen = 0;
    let forecasts = 0;
    const legend = [];
    const datasets = trend.series.map(s => {
      const st = styleOf(s, s.kind === 'past' ? pastTotal - 1 - seen++ : s.kind === 'forecast' ? forecasts++ : 0);
      legend.push({ label: s.label, color: st.color });
      return {
        label: s.label,
        data: s.data,
        borderColor: st.color,
        backgroundColor: st.color,
        borderWidth: st.width,
        pointRadius: st.point,
        pointHoverRadius: 0,
        tension: 0,
        spanGaps: false,
      };
    });
    return {
      data: { labels: trend.labels, datasets },
      legend,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        events: [],
        layout: { padding: { top: 4, right: 4 } },
        plugins: { legend: { display: false }, tooltip: { enabled: false }, datalabels: { display: false } },
        scales: {
          x: { grid: { display: false }, ticks: { color: '#8094B5', font: { size: 11 }, maxRotation: 0, autoSkip: false } },
          y: { grid: { color: '#EDF1F8' }, ticks: { color: '#8094B5', font: { size: 11 }, maxTicksLimit: 5, callback: v => trend.fmt(v) } },
        },
      },
    };
  }, [trend]);

  if (!trend || !data) return null;
  return (
    <div data-testid="row-trend" style={sx(`position:fixed;left:${vm.chartLeft};top:${vm.chartTop};z-index:80;width:520px;padding:14px 16px 12px;border:1px solid #DCE4F2;border-radius:12px;background:#fff;box-shadow:0 12px 28px -12px rgba(8,35,76,0.35);pointer-events:none`)}>
      <div style={sx(`font-size:12px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;color:#0052CD;margin-bottom:8px`)}>{vm.chartName}</div>
      <div style={sx(`height:240px`)}>
        <Line data={data} options={options} />
      </div>
      <div style={sx(`margin-top:8px;display:flex;flex-wrap:wrap;gap:4px 14px;font-size:11.5px;color:var(--ink-4)`)}>
        {legend.map(l => (
          <span key={l.label} style={sx(`display:flex;align-items:center;gap:5px`)}>
            <span style={sx(`width:14px;height:3px;border-radius:2px;background:${l.color}`)}></span>
            {l.label}
          </span>
        ))}
      </div>
    </div>
  );
}
